import React from "react";
import { convertStraight, convertThenFormat } from "../../common-data/Converts";

const PaymentInfoMobile = ({ tableData, onClickActionBtn }) => {
  return (
    <div className="all-leads-log mt30">
      {tableData?.length > 0 &&
        tableData.map((lead, index) => {
          return (
            <div className="log-card" key={index}>
              <div className="all-info">
                <div className="log-card-top">
                  <h3 className="lead-name">
                    {lead?.date ? convertStraight(lead.date) : "-"}
                  </h3>

                  <span
                    className={`lead-type ${lead?.amount}`}
                    style={{
                      backgroundColor: "#5F5DF0",
                      color: "#fff",
                    }}
                  >
                    ₹{convertThenFormat(lead?.amount || 0)}
                  </span>
                </div>

                <div
                  className="lead-multi-value-cols px20px pb20px"
                  style={{ marginTop: "10px" }}
                >
                  <div className="label-value">
                    <span className="label">Status</span>
                    <span
                      className="value"
                      style={{
                        background:
                          lead?.status === "completed" ? "#379C00" : "#CD0909",
                        color: "#fff",
                        padding: "5px 10px",
                        borderRadius: "4px",
                        letterSpacing: "1px",
                      }}
                    >
                      {lead?.status || "NA"}
                    </span>
                  </div>
                </div>

                {lead?.status !== "completed" ? (
                  <div className="all-btns lead-btn-axceed">
                    <div className="lead-log-box" style={{ width: "40%" }}>
                      <button
                        className="lead-log view-lead"
                        onClick={(e) => onClickActionBtn(e, lead, "cash")}
                        style={{
                          width: "auto",
                          height: "auto",
                          padding: "10px",
                          // background: "#F3DADA",
                          // color: "#D90000",
                          background: "#D90000",
                          color: "#fff",
                          cursor: "pointer",
                        }}
                      >
                        Collect Cash
                      </button>
                    </div>
                    <div className="lead-log-box" style={{ width: "40%" }}>
                      {/* Direct collection — parent (OnlineCashCollect)
                          prompts for trx id when name='online'. Old "Send
                          Link" cashfree flow is removed per requirement. */}
                      <button
                        className="lead-log view-lead"
                        onClick={(e) => onClickActionBtn(e, lead, "online")}
                        style={{
                          width: "auto",
                          height: "auto",
                          padding: "10px",
                          background: "#3474F1",
                          color: "#fff",
                          cursor: "pointer",
                        }}
                      >
                        Collect Online
                      </button>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default PaymentInfoMobile;
